import "@/helpers/turbo"

import NewsletterController from "../controllers/newsletter_controller"
import RecaptchaController from "../controllers/recaptcha_controller"
import { register } from "@/helpers/stimulus"

const setupStimulus = (): void => {
  register("newsletter", NewsletterController)
  register("recaptcha", RecaptchaController)
}

setupStimulus()
